var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 25,
    fill: "#F59E0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1199 15.5089L23.1049 15.5L26.1898 32.2406L27.9188 21.6333L28.1457 20.2416L28.8462 21.4653L30.5056 24.3638H37.5V25.3638H30.2157H29.9258L29.7818 25.1122L28.6789 23.1858L26.7134 35.2438L25.7282 35.254L22.6395 18.4925L21.0202 28.2725L20.7393 29.9685L20.0667 28.3864L18.7817 25.3638H12.5V24.3638H19.1124H19.4432L19.5726 24.6682L20.3144 26.4131L22.1199 15.5089Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewStatus);
export default __webpack_public_path__ + "static/media/ViewStatus.63d2a79286f9a5dbf705f06a13a2743e.svg";
export { ForwardRef as ReactComponent };